import React from 'react'

const Pagination = ({
  currentPage,
  totalPages,
  itemsPerPage,
  totalItems,
  onPageChange,
  className = ""
}) => {
  if (totalPages <= 1) return null

  const startItem = currentPage * itemsPerPage + 1
  const endItem = Math.min((currentPage + 1) * itemsPerPage, totalItems)

  return (
    <div className={`d-flex justify-content-between align-items-center mt-3 ${className}`}>
      <div>
        Showing {startItem} to {endItem} of {totalItems} entries
      </div>
      <div>
        <button
          className="btn btn-sm btn-outline-primary me-2"
          disabled={currentPage === 0}
          onClick={() => onPageChange(currentPage - 1)}
        >
          Prev
        </button>
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            className={`btn btn-sm border me-2 ${
              currentPage === i ? "btn-primary text-white" : ""
            }`}
            onClick={() => onPageChange(i)}
          >
            {i + 1}
          </button>
        ))}
        <button
          className="btn btn-sm btn-outline-primary"
          disabled={currentPage === totalPages - 1}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next
        </button>
      </div>
    </div>
  )
}

export default Pagination
